import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements AfterViewInit {
  @ViewChild('redirectToPaymentPageForm', { static: false })
  redirectToPaymentPageForm: ElementRef;
  @ViewChild('TransactionID', { static: false })
  TransactionID: ElementRef;
  form: any = {}
  constructor() { 
    this.form.PaymentPage = sessionStorage.getItem("PaymentPage")
     this.form.TransactionID = sessionStorage.getItem("TransactionID")
    } 

        ngAfterViewInit(){
          this.submitForm();
      }
      
    submitForm() {
      this.redirectToPaymentPageForm.nativeElement.action = this.form.PaymentPage;
        this.TransactionID.nativeElement.value = this.form.TransactionID;
        this.redirectToPaymentPageForm.nativeElement.submit();
    }
}
